export default {
    AddressType: 'Address Type',
    CountyName: 'County Name',
    CountryRemoved: 'Country Removed!',
    CityRemoved: 'City Removed!',
    NewCountryAdd: 'New Country Add',
    NewCityAdd: 'New City Add',
    Faild: 'Faild',
    NewProvinceAdd: 'New Province Add',
    UpdateCountry: 'Country Update',
    UpdateCity: 'City Update',
    UpdateProvince: 'Update Province',
    ProvinceRemoved: 'Province Removed',
    ZonsRemove: 'Zons Remove',
    UpdateZons: 'Update Zons',
    NewZonsAdd: 'New Zons Add',
    NewAddressAdd: 'New Address Add',
    UpdateAddress: 'Update Address',
    RemoveAddress: 'Remove Address',
    EditFor: 'Edit For',
    Addresses: 'Addresses',
    Address: 'Address',
    CountryName: 'Country Name',
    CityName: 'City Name',
    Citys: 'Citys',
    City: 'City',
    Enable: 'Enable',
    Latitude: 'Latitude',
    Longitude: 'Longitude',
    Location: 'Location',
    ProvinceName: 'Province Name',
    Provinces: 'Provinces',
    PostalCode: 'Postal Code',
    Phone: 'phone',
    Priority: 'Priority',
    ZoneName: 'Zons Name',
    Disable: 'Disable',
    Slug: 'Slug',
    Title: 'Title',
    Zons: 'Zons',
    OriginalAddress: 'Original Address',
    Order: 'Order',
    areYouSureYouWantToDeleteThisAddress: 'Are you sure you want to delete this address?',
    mainAreas: 'Main areas',
    suburbsAreas: 'Suburbs areas',
    area: 'Area',
    newArea: 'New area',
    systematicExpand: 'Systematic expand',
    extensionRadius: 'Extension radius',
    zone: 'Zone',

    countyName: 'County Name',
    postalCode: 'Postal Code',
    phone: 'phone',
    countryName: 'Country Name',
    cityName: 'City Name',
    provinceName: 'Province Name',
    originalAddress: 'Original Address',
    location: 'Location',
    address: 'Address',
    province: 'Province',
    city: 'City',
    countryId: 'Country ID',
    provinceId: 'Province ID',
    countyId: 'County ID',
    cityId: 'City ID',
    districtId: 'District ID',
    trafficPlanId: 'Traffic plan ID',
    addresses: 'Addresses',
    online: 'Online',
    offline: 'Offline',
    failureToUpdateLocation: 'Failure to update position',
    failureToPostLocation: 'Failure to post position'
}